/**
 * 预览子组件-预览iframe操作组件
 * @author chenqunfeng
 * @since 17/11/15
 */

import './iframe-operation-bar.less';

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { RP_SPA, POSTER } from 'constants/variable.json5';

class PreviewPrice extends Component {
  static propTypes = {
    data: PropTypes.object,
  };

  // 上一页
  prevPage() {
    const iframe = document.querySelector('.s-preview-iframe iframe');

    iframe.contentWindow.postMessage(JSON.stringify({ code: 'PREV' }), '*');
  }

  // 下一页
  nextPage() {
    const iframe = document.querySelector('.s-preview-iframe iframe');

    iframe.contentWindow.postMessage(JSON.stringify({ code: 'NEXT' }), '*');
  }

  render() {
    const { data } = this.props;
    const { type } = data;

    return (
      <div className="s-preview-iframe-operation">
        {type !== RP_SPA && type !== POSTER && (
          <div>
            <div
              className="s-preview-prev-page s-icon icon-up1"
              onClick={this.prevPage}
            />
            <div
              className="s-preview-next-page s-icon icon-up1"
              onClick={this.nextPage}
            />
          </div>
        )}
      </div>
    );
  }
}

export default PreviewPrice;
